const tabs = {
    get_started: '開始上手',
    dashboard: '儀表板',
    applications: '全部應用',
    api_resources: 'API 資源',
    sign_in_experience: '登入體驗',
    connectors: '連接器',
    enterprise_sso: 'Enterprise SSO',
    webhooks: 'Webhooks',
    organizations: '組織',
    users: '使用者管理',
    audit_logs: '稽核日誌',
    roles: '角色',
    docs: '文件',
    tenant_settings: '租戶設定',
    mfa: '多重認證',
    /** UNTRANSLATED */
    customize_jwt: 'JWT Claims',
    signing_keys: '簽署密鑰',
    organization_template: '組織模板',
};
export default Object.freeze(tabs);
